import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/experience.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/chapters.css");
